import { Link } from 'react-router-dom';
import NavLinks from './NavLinks';
import PrimaryButton from '../common/PrimaryButton'
import useHeaderScroll from '../../hooks/useHeaderScroll';
import Container from '../ui/Container';
import logo from '../../assets/images/logo/logo-new.svg';
import { useDispatch } from 'react-redux';
import { toggleNav } from '../../features/nav/navslice';

export default function Header() {
  const isVisible = useHeaderScroll();
  const dispatch = useDispatch();

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full border-b border-white/10 backdrop-blur-md transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'
        }`}
    >
      <Container className="mx-auto flex max-w-[72.6rem] items-center justify-between px-6 py-4">
        {/* Logo */}
        <Link to="/" className="shrink-0">
          <img
            src={logo}
            alt="Stronghold Security"
            className=""
            width="135px" height="100%"
          />
        </Link>

        {/* Navigation */}
        <NavLinks />

        {/* CTA */}
        <div className="hidden lg:block">
          <PrimaryButton to="/contact-us" className="cursor-pointer">Contact Us</PrimaryButton>
        </div>

        <button
          className="lg:hidden text-white"
          onClick={() => dispatch(toggleNav())}
        >
          ☰
        </button>
      </Container>
    </header>
  );
}